"use client";

import React, { useState } from "react";
import { Button } from "@/components/ui/button";
const categories = ["Wellness", "Hormones", "Gut Health", "Weight Loss", "Founder Life", "Protocol Insights"];
export default function CategoriesTagsFilterSection() {
  const [activeCategory, setActiveCategory] = useState<string>("Wellness");
  return <section id="categoriestags-filter-section" className="bg-background py-12 md:py-20">
      <div className="container mx-auto px-4">
        <div className="flex flex-wrap items-center justify-center gap-3 md:gap-4">
          {categories.map((category, i) => {
          const isActive = activeCategory === category;
          return <Button key={category} data-index={i} variant="secondary" onClick={() => setActiveCategory(category)} className={`h-auto rounded-full px-6 py-2.5 text-sm font-medium transition-all duration-300 md:text-base shadow-none ${isActive ? "bg-[var(--color-green-accent)] text-primary-foreground hover:bg-[var(--color-green-accent)]/90" : "bg-secondary text-secondary-foreground hover:bg-secondary/80"}`}>
                {category}
              </Button>;
        })}
        </div>
      </div>
    </section>;
}